import { useEffect, useState } from 'react'
import type { Cart } from '../types/display'

/** How long "You saved" holds the stage before the order takes it back. */
export const SAVED_FOR_MS = 4500

export interface SavedMoment {
  amount: number
  /** Bumps on every new saving, so a second discount replays. */
  seq: number
}

/**
 * The moment a discount lands or grows: the saving, for a few seconds. A
 * discount going down or away is not a moment. Derived while rendering, then
 * cleared by a timer.
 */
export function useSavedMoment(cart: Cart | null): SavedMoment | null {
  const discount = cart?.discountAmount ?? 0
  const [previous, setPrevious] = useState(discount)
  const [moment, setMoment] = useState<SavedMoment | null>(null)

  if (discount !== previous) {
    setPrevious(discount)
    if (discount > previous) setMoment({ amount: discount, seq: (moment?.seq ?? 0) + 1 })
    else setMoment(null)
  }

  useEffect(() => {
    if (!moment) return
    const timer = setTimeout(() => setMoment(null), SAVED_FOR_MS)
    return () => clearTimeout(timer)
  }, [moment])

  return moment
}
